import { Layout } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { NotFound } from 'src/component/app/NotFound'
import * as routes from 'src/constants/routes'
import { useUser } from 'src/context/UserContext'
import { FormMode, isAdmin, isAgencyAdmin, isAgencyManager, isAuthenticated, setLoggedUserProps } from '../../util/Util'
import '../root/common.css'
import AccountCreate from './account/AccountCreate'
import AccountEdit from './account/AccountEdit'
import AccountList from './account/AccountList'
import AdGroupCreate from './adGroup/AdGroupCreate'
import AdGroupEdit from './adGroup/AdGroupEdit'
import AdGroupList from './adGroup/AdGroupList'
import AdSizeCreate from './adSize/AdSizeCreate'
import AdSizeEdit from './adSize/AdSizeEdit'
import AdSizeList from './adSize/AdSizeList'
import AdvertiserCreate from './advertiser/AdvertiserCreate'
import AdvertiserEdit from './advertiser/AdvertiserEdit'
import AdvertiserList from './advertiser/AdvertiserList'
import { Breadcrumb } from './breadcrumb/Breadcrumb'
import CampaignCreate from './campaign/CampaignCreate'
import CampaignEdit from './campaign/CampaignEdit'
import CampaignList from './campaign/CampaignList'
import CreativeBulk from './creative/CreativeBulk'
import CreativeCreate from './creative/CreativeCreate'
import CreativeEdit from './creative/CreativeEdit'
import CreativeList from './creative/CreativeList'
import { Dashboard } from './dashboard/Dashboard'
import FilterListCreate from './filterList/FilterListCreate'
import FilterListEdit from './filterList/FilterListEdit'
import FilterLists from './filterList/FilterLists'
import ContextualTargetingList from './contextualTargeting/ContextualTargetingList'
import FraudDomainList from './fraudDomain/FraudDomainList'
import LogList from './log/LogList'
import MediaAgencyCreate from './mediaAgency/MediaAgencyCreate'
import MediaAgencyEdit from './mediaAgency/MediaAgencyEdit'
import MediaAgencyList from './mediaAgency/MediaAgencyList'
import NotificationSettingEdit from './notificationSetting/NotificationSettingEdit'
import NotificationSettingList from './notificationSetting/NotificationSettingList'
import { Report } from './report/Report'
import { TrackerReport } from './trackerReport/TrackerReport'
import { KeywordReport } from './keywordReport/KeywordReport'
import TestRequest from './request/TestRequest'
import RetargetingListCreate from './retargetingList/RetargetingListCreate'
import RetargetingListEdit from './retargetingList/RetargetingListEdit'
import RetargetingLists from './retargetingList/RetargetingLists'
import SavedReportList from './savedReport/SavedReportList'
import { Sidebar } from './sidebar/Sidebar'
import SspCreate from './ssp/SspCreate'
import SspEdit from './ssp/SspEdit'
import SspList from './ssp/SspList'
import TrackerCreate from './tracker/TrackerCreate'
import TrackerEdit from './tracker/TrackerEdit'
import TrackerList from './tracker/TrackerList'

const AntContent = Layout.Content

export const App: React.FC = () => {

    const { user, setUser } = useUser()
    const [selectedMenuKeys, setSelectedMenuKeys] = useState([''])

    const location = useLocation()

    useEffect(() => {
        if (isAuthenticated()) {
            setLoggedUserProps(setUser)
        }
    }, [])

    useEffect(() => {
        const key = location.pathname.substring(1)
        if (key == '') {
            setSelectedMenuKeys(['campaign'])
        } else {
            setSelectedMenuKeys([key.split('/')[0]])
        }
    }, [location])

    const admin = isAdmin(user)
    const agencyAdmin = isAgencyAdmin(user)
    const agencyManager = isAgencyManager(user)

    return isAuthenticated() ? (
        <Layout>
            <Sidebar
                selectedKeys={selectedMenuKeys}
            />
            <Layout>
                <AntContent style={{ height: '100%' }}>
                    <div className="utils__content">
                        <Breadcrumb />
                        <Routes>
                            <Route path={routes.ACCOUNT_CREATE} element={admin ? <AccountCreate /> : <NotFound />} />
                            <Route path={routes.ACCOUNT_EDIT} element={admin ? <AccountEdit /> : <NotFound />} />
                            <Route path={routes.ACCOUNT} element={admin ? <AccountList /> : <NotFound />} />

                            <Route path={routes.MEDIA_AGENCY_CREATE} element={admin || agencyAdmin ? <MediaAgencyCreate /> : <NotFound />} />
                            <Route path={routes.MEDIA_AGENCY_EDIT} element={admin || agencyAdmin ? <MediaAgencyEdit /> : <NotFound />} />
                            <Route path={routes.MEDIA_AGENCY} element={admin || agencyAdmin ? <MediaAgencyList /> : <NotFound />} />

                            <Route path={routes.SSP_CREATE} element={admin ? <SspCreate /> : <NotFound />} />
                            <Route path={routes.SSP_EDIT} element={admin ? <SspEdit /> : <NotFound />} />
                            <Route path={routes.SSP} element={admin ? <SspList /> : <NotFound />} />

                            <Route path={routes.ADVERTISER_CREATE} element={admin || agencyAdmin || agencyManager ? <AdvertiserCreate /> : <NotFound />} />
                            <Route path={routes.ADVERTISER_EDIT} element={admin || agencyAdmin || agencyManager ? <AdvertiserEdit /> : <NotFound />} />
                            <Route path={routes.ADVERTISER} element={admin || agencyAdmin || agencyManager ? <AdvertiserList /> : <NotFound />} />

                            <Route path={routes.CAMPAIGN_CREATE} element={admin || agencyAdmin || agencyManager ? <CampaignCreate /> : <NotFound />} />
                            <Route path={routes.CAMPAIGN_EDIT} element={admin || agencyAdmin || agencyManager ? <CampaignEdit /> : <NotFound />} />
                            <Route path={routes.CAMPAIGN} element={admin || agencyAdmin || agencyManager ? <CampaignList /> : <NotFound />} />

                            <Route path={routes.AD_GROUP_CREATE} element={admin || agencyAdmin || agencyManager ? <AdGroupCreate /> : <NotFound />} />
                            <Route path={routes.AD_GROUP_EDIT} element={admin || agencyAdmin || agencyManager ? <AdGroupEdit /> : <NotFound />} />
                            <Route path={routes.AD_GROUP} element={admin || agencyAdmin || agencyManager ? <AdGroupList /> : <NotFound />} />

                            <Route path={routes.CREATIVE_CREATE} element={admin || agencyAdmin || agencyManager ? <CreativeCreate /> : <NotFound />} />
                            <Route path={routes.CREATIVE_BULK} element={admin || agencyAdmin || agencyManager ? <CreativeBulk /> : <NotFound />} />
                            <Route path={routes.CREATIVE_EDIT} element={admin || agencyAdmin || agencyManager ? <CreativeEdit /> : <NotFound />} />
                            <Route path={routes.CREATIVE} element={admin || agencyAdmin || agencyManager ? <CreativeList /> : <NotFound />} />

                            <Route path={routes.AD_SIZE_CREATE} element={admin ? <AdSizeCreate /> : <NotFound />} />
                            <Route path={routes.AD_SIZE_EDIT} element={admin ? <AdSizeEdit /> : <NotFound />} />
                            <Route path={routes.AD_SIZE} element={admin ? <AdSizeList /> : <NotFound />} />

                            <Route path={routes.FILTER_LIST_CREATE} element={admin || agencyAdmin || agencyManager ? <FilterListCreate /> : <NotFound />} />
                            <Route path={routes.FILTER_LIST_EDIT} element={admin || agencyAdmin || agencyManager ? <FilterListEdit /> : <NotFound />} />
                            <Route path={routes.FILTER_LIST} element={admin || agencyAdmin || agencyManager ? <FilterLists /> : <NotFound />} />

                            <Route path={routes.RETARGETING_LIST_CREATE} element={admin || agencyAdmin || agencyManager ? <RetargetingListCreate /> : <NotFound />} />
                            <Route path={routes.RETARGETING_LIST_EDIT} element={admin || agencyAdmin || agencyManager ? <RetargetingListEdit /> : <NotFound />} />
                            <Route path={routes.RETARGETING_LIST} element={admin || agencyAdmin || agencyManager ? <RetargetingLists /> : <NotFound />} />

                            <Route path={routes.FRAUD_DOMAIN} element={admin ? <FraudDomainList /> : <NotFound />} />

                            <Route path={routes.CONTEXTUAL_TARGETING} element={admin ? <ContextualTargetingList /> : <NotFound />} />

                            <Route path={routes.TRACKER_CREATE} element={admin ? <TrackerCreate /> : <NotFound />} />
                            <Route path={routes.TRACKER_EDIT} element={admin ? <TrackerEdit /> : <NotFound />} />
                            <Route path={routes.TRACKER} element={admin ? <TrackerList /> : <NotFound />} />

                            <Route path={routes.TEST_REQUEST} element={admin ? <TestRequest /> : <NotFound />} />

                            <Route path={routes.NOTIFICATION_SETTING_EDIT} element={admin ? <NotificationSettingEdit /> : <NotFound />} />
                            <Route path={routes.NOTIFICATION_SETTING} element={admin ? <NotificationSettingList /> : <NotFound />} />

                            <Route path={routes.SAVED_REPORT} element={<SavedReportList />} />
                            <Route path={routes.REPORT_BUILDER} element={<Report mode={FormMode.create} />} />
                            <Route path={routes.REPORT_COPY} element={<Report mode={FormMode.copy} />} />
                            <Route path={routes.REPORT_EDIT} element={<Report mode={FormMode.edit} />} />
                            <Route path={routes.REPORT} element={<Report mode={FormMode.edit} autoLoad={true} />} />

                            <Route path={routes.TRACKER_REPORT} element={admin ? <TrackerReport /> : <NotFound />} />
                            <Route path={routes.KEYWORD_REPORT} element={admin ? <KeywordReport /> : <NotFound />} />

                            <Route path={routes.LOG} element={admin ? <LogList /> : <NotFound />} />

                            <Route path={routes.DASHBOARD} element={admin || agencyAdmin || agencyManager ? <Dashboard /> : <NotFound />} />

                            <Route path="/" element={<CampaignList />} />
                        </Routes>
                    </div>
                </AntContent>
            </Layout>
        </Layout>
    ) : (<Navigate to={'/login'} />)
}



// WEBPACK FOOTER //
// ./src/component/app/App.tsx